import { Button } from "@mui/material";

function ButtonCustomized({
  variant = "outlined",
  startIcon,
  endIcon,
  title,
  auth = false,
  onClick,
}) {
  return (
    <Button
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={{
        height: auth ? "30px" : undefined,
        position: auth ? "relative" : undefined,
        alignSelf: auth ? "flex-end" : undefined,
        fontSize: "0.8rem",
        padding: "2px 12px",
        border: "2px solid #25384a",
        fontWeight: "bold",
        textTransform: "none",
        "&:hover": {
          border: "2px solid #25384a",
        },
        "&:focus": {
          border: "2px solid #25384a",
        },
        boxShadow: "none",
      }}
      variant={variant}
    >
      {title}
    </Button>
  );
}

export default ButtonCustomized;
